import { keyBy, compact } from 'lodash';
import { Assignment } from './Assignment';
import { AssignmentComplete, AssignmentType } from './AssignmentComplete';
import { AssignmentMeta } from './AssignmentMeta';

export interface AssignmentData<T extends AssignmentType = AssignmentType> {
  meta: AssignmentMeta;
  assignment: Assignment<T>;
}

export namespace AssignmentData {
  export type Realtime = AssignmentData<'realtime'>;

  export function from(assignments: Assignment[], metas: AssignmentMeta[]): AssignmentData[] {
    const assignmentMap = keyBy(assignments, (a) => a._id);

    const results = metas.map((meta): AssignmentData | undefined => {
      const assignment = assignmentMap[meta._id];
      return assignment && { assignment, meta };
    });

    return compact(results);
  }

  export function fromComplete(complete: AssignmentComplete): AssignmentData {
    return {
      assignment: Assignment.from(complete.content, complete.settings),
      meta: complete.meta,
    };
  }

  export function isRealtime(data: AssignmentData): data is AssignmentData.Realtime {
    return Assignment.isRealtime(data.assignment);
  }
}
